import type { AlertOptions } from '@flash-global66/g-dialog-alert';

export const alertCloseOtpTransaction: AlertOptions = {
  type: 'warning',
  title: 'Confirmar cancelación',
  description:
    '¿Estás seguro de que deseas cancelar la transacción? Podrás iniciar un nuevo proceso más tarde si lo necesitas.',
  primaryText: 'Volver',
  secondaryText: 'Cancelar transacción',
};
